import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { formatPhoneInput } from './utils';

const CustomerInfoForm = ({
  customerName,
  setCustomerName,
  customerPhone,
  setCustomerPhone,
  customerEmail,
  setCustomerEmail
}) => {
  const handlePhoneChange = (e) => {
    const formatted = formatPhoneInput(e.target.value);
    setCustomerPhone(formatted);
  };

  return (
    <>
      <div className="space-y-2">
        <Label>Your Name *</Label>
        <Input
          type="text"
          placeholder="Enter your full name"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          data-testid="name-input"
          required
        />
        <p className="text-xs text-muted-foreground">This will be printed on cover page</p>
      </div>

      <div className="space-y-2">
        <Label>Mobile Number *</Label>
        <div className="flex gap-2">
          <div className="flex items-center px-3 py-2 border border-border rounded-md bg-secondary">
            <span className="font-medium">+91</span>
          </div>
          <Input
            type="tel"
            placeholder="9876543210"
            value={customerPhone}
            onChange={handlePhoneChange}
            maxLength="10"
            data-testid="phone-input"
            className="flex-1"
          />
        </div>
        <p className="text-xs text-muted-foreground">Enter 10-digit mobile number</p>
      </div>

      <div className="space-y-2">
        <Label>Email (optional, for receipt)</Label>
        <Input
          type="email"
          placeholder="your@email.com"
          value={customerEmail}
          onChange={(e) => setCustomerEmail(e.target.value)}
          data-testid="email-input"
        />
      </div>
    </>
  );
};

export default CustomerInfoForm;
